import { DSSize } from '@teko/types/shared';
import React from 'react';
import { DefaultCountdown } from './DefaultCountdown.es.js';
import { useTimer } from '../../hooks/useTimer.es.js';

const DefaultRenderer = (duration, size = DSSize.default) => /* @__PURE__ */ React.createElement(DefaultCountdown, {
  duration,
  size
});
const Countdown = ({
  date,
  renderer = DefaultRenderer,
  size = DSSize.default,
  className
}) => {
  const timer = useTimer(date);
  return /* @__PURE__ */ React.createElement("div", {
    className
  }, renderer && renderer(timer, size));
};

export { Countdown };
